/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Enum for the different types of damages that can be reported
 */
export enum DamageTypeEnum {
  /**
   * Damage to the glass components (windshield, windows, etc.)
   */
  GLASS_DAMAGE = "GLASS_DAMAGE",

  /**
   * Damage caused during parking or maneuvering
   */
  MANEUVERING_DAMAGE = "MANEUVERING_DAMAGE",

  /**
   * Damage that occurred during normal operation of the vehicle
   */
  OPERATIONAL_DAMAGE = "OPERATIONAL_DAMAGE",

  /**
   * Damage that occurred during encounter with opposing traffic
   */
  ONCOMING_TRAFFIC_DAMAGE = "ONCOMING_TRAFFIC_DAMAGE",

  /**
   * Damage caused by collision with an animal
   */
  ANIMAL_DAMAGE = "ANIMAL_DAMAGE",

  /**
   * Damage caused by collision with or by a wild animal
   */
  WILD_ANIMAL_DAMAGE = "WILD_ANIMAL_DAMAGE",

  /**
   * Damage caused specifically by martens (cable biting, etc.)
   */
  MARTEN_DAMAGE = "MARTEN_DAMAGE",

  /**
   * Damage caused by hail (typically covered by partial coverage insurance)
   */
  HAIL_DAMAGE = "HAIL_DAMAGE",

  /**
   * Theft of parts or attempted break-in
   */
  PARTS_THEFT_BREAK_IN = "PARTS_THEFT_BREAK_IN",

  /**
   * Complete theft of the vehicle
   */
  TOTAL_THEFT = "TOTAL_THEFT",

  /**
   * Vehicle damaged beyond economical repair
   */
  TOTAL_LOSS = "TOTAL_LOSS",

  /**
   * "Gewaltschaden"
   */
  EXTERNAL = "EXTERNAL",

  /**
   * "Wartun/Service"
   */
  MAINTENANCE = "MAINTENANCE",

  /**
   * Damage caused by vandalism (e.g. intentional destruction or defacement)
   */
  VANDALISM = "VANDALISM",

  /**
   * Damage with unknown cause or type
   */
  UNKNOWN = "UNKNOWN",

  /**
   * Other type
   */
  OTHER = "OTHER"
}
